module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/restaurants_2-36f2412977d94027cdb067e4d8469867.jpg";